import { FC, useMemo } from 'react';
import { GenericTabs } from 'src/presentations/components/molecules/tabs/GenericTabs';
import { ITabOption } from 'src/presentations/components/molecules/tabs/types';
import { IPerformanceTabsProps } from './types';
import { TableTab } from '../analytics/table/useTable';

export const PerformanceTabs: FC<IPerformanceTabsProps> = (props) => {
  const { selected, onChangeTab } = props;

  const menuItems = useMemo<ITabOption[]>(
    () => [
      {
        value: TableTab.SAVINGS,
        label: 'Savings',
      },
      {
        value: TableTab.VOLUMETRIC,
        label: 'Volumetrics',
      },
    ],
    []
  );

  return (
    <div className='px-16 xl:px-32 py-12 xl:py-16 bg-white flex items-center shadow-[0_6px_20px_0_rgba(0,0,0,0.04)]'>
      <GenericTabs options={menuItems} onChange={onChangeTab} defaultSelected={selected} className='!w-[20rem]' />
    </div>
  );
};
